import getters from './modules/getters'

export default { getters }
